import { useCallback, useEffect, useState } from "react";
import { _StatesCatalog } from "../../../../core/services/dataBean/EntityCatalogVdos"
import useDataBean from "../../../../core/services/dataBean/useDataBean"
import { PrintJson } from "../../../theme/Component/PrintJson";
import { CitiView } from "./CitiView";

interface Props {
    idCountry: number
}
export const StatesView = ({ idCountry }: Props) => {

    const _state = useDataBean(_StatesCatalog);
    const { bean, setBean, lista, setLista, instance } = _state;
    const [child, setChild] = useState<number>(0);



    const getStates = useCallback(() => {
        if (!idCountry) return;
        instance.getStatesCatalog(idCountry, null, 1, 100).then(
            (resp: any) => {
                const sortedList = (resp.List || []).sort((a: any, b: any) =>
                    (a.DataBeanProperties.Name || "").localeCompare(b.DataBeanProperties.Name || "")
                );
                setLista(sortedList);
            }
        )
    }, [idCountry, instance, setLista])

    useEffect(() => {
        getStates();
    }, [getStates]);

    return (
        <div className="row">
            <div className="col-md-12">
                <div className="col-md-12">
                    <ul className="list-group">
                        {lista.length > 0 &&
                            lista.map((item: any, index: number) => {
                                return (
                                    <li key={index} className="list-group-item itemh" onClick={() => { setBean(item.DataBeanProperties) }}>

                                        <strong className={child === item.DataBeanProperties.IDStates ? 'cursor treeselect' : 'cursor'} onClick={() => {
                                            localStorage.setItem('SiteID', JSON.stringify(item.DataBeanProperties));
                                            setChild(item.DataBeanProperties.IDStates);

                                        }}>
                                            <strong style={{ marginLeft: '15px' }}>{item.DataBeanProperties.IDStates} </strong>
                                            <small>{item.DataBeanProperties.Name}</small>
                                        </strong>
                                        {/* <span className="badge bg-success ms-1">{item.ChildrenCount}</span> */}
                                        {(child === item.DataBeanProperties.IDStates) &&
                                            <CitiView state={item.DataBeanProperties} />
                                            // <SiteIDChilds edit={edit} idChild={item.DataBeanProperties.IDLn} editBean={(item: any) => { setBean(item) }} />
                                        }
                                    </li>
                                );
                            })}
                    </ul>
                </div>
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    )
}